<template>
  <div>
    <v-dialog
    v-model="error"
    width="500"
    >

      <v-card>
        <v-card-title
          class="headline red accent-3"
          primary-title
        >
          Warning Message
        </v-card-title>

        <v-card-text>
          {{errorMsg}}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red accent-3"
            flat
            @click="setErrorZero"
          >
            close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-toolbar flat color="white">
      <v-toolbar-title>NID Status Rejected</v-toolbar-title>
        <!-- <v-divider
          class="mx-2"
          inset
          vertical
        ></v-divider> -->
       <v-spacer></v-spacer>
       <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        align="center"
      ></v-text-field>
      <v-spacer></v-spacer>
      <!-- view page start here -->
      <v-dialog v-model="dialog">
        <template>
          <v-layout row>
            <v-flex xs12 sm6 offset-sm3>
              <v-container fluid>
              <v-card>
                <v-card-title class="indigo white--text">
                  <div class="headline">Dasher Details</div>
                </v-card-title>
                <v-card-text>
                  <v-layout row>
                    <v-flex xs6>
                      <div class="subheading">
                        <b> Full Name:</b> {{ editedItem.full_name }}
                      </div>
                    </v-flex>
                    <v-flex xs6>
                      <div class="subheading">
                        <b> NID Number:</b> {{ editedItem.nid_number }}
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex xs6>
                      <div class="subheading">
                        <b>DOB:</b> {{ editedItem.dob }}
                      </div>
                    </v-flex>
                    <v-flex xs6>
                      <div class="subheading">
                        <b>Gender:</b> {{ editedItem.gender_name }}
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                  <v-flex>
                    <div class="subheading">
                      <b>Rejection Reason:</b> {{editedItem.components}}
                    </div>
                  </v-flex>
                </v-layout>

                  <v-layout row mt-3>
                    <v-flex xs6 mr-1 v-if="editedItem.nid_front_page">
                      <div class="subheading">National ID Card Front Page</div>
                      <v-img :src="indexData.nidImage + editedItem.nid_front_page" ></v-img>
                      <a :href="indexData.nidImage + editedItem.nid_front_page" target="_blank">download</a>
                    </v-flex>
                    <v-flex xs6 mr-1 v-if="editedItem.nid_back_page">
                      <div class="subheading">National ID Card Back Page</div>
                      <v-img :src="indexData.nidImage + editedItem.nid_back_page" ></v-img>
                      <a :href="indexData.nidImage + editedItem.nid_back_page" target="_blank">download</a>
                    </v-flex>
                </v-layout>
                </v-card-text>  

              </v-card>

            </v-container>
          </v-flex>
        </v-layout>
        <!-- <v-divider inset></v-divider> -->
        <v-container fluid>
          <v-layout row>
            <div>
              <v-btn color="red" @click="close">Cancel</v-btn>
            </div>
          </v-layout>
        </v-container>
      </template>
    </v-dialog>
      <!-- view page end here -->
    </v-toolbar>
     <div v-if="alertMsg">
        <v-alert v-if="error == 0 && statusCode == 200" :value="true" type="success" transition="slide-y-reverse-transition">{{ errorMsg }}</v-alert>
        <v-alert v-if="error == 1 && statusCode == 204" :value="true" type="info" transition="slide-y-reverse-transition">{{ errorMsg }}</v-alert>
        <v-alert v-if="error == 1 && (statusCode == 403 || statusCode == 400)" :value="true" type="warning" transition="slide-y-reverse-transition">{{ errorMsg }}</v-alert>
        <v-alert v-if="error == 1 && statusCode == 500" :value="true" type="error" transition="slide-y-reverse-transition">{{ errorMsg }}</v-alert>
     </div>
    <div v-if="isLoaded">
      <div v-if="indexData.totalRejected < 1" class="text-xs-center">
        <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>

      </div>
      <v-data-table
        :headers="headers"
        :items="indexData.userRejectedInfos.data"
        :search="search"
        :pagination.sync="pagination"
        :rows-per-page-items="rowsPerPageItems"
        hide-actions
        class="elevation-1"
      >
      <v-progress-linear color="blue" indeterminate></v-progress-linear>
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span v-on="on">
                {{ props.header.text }}
              </span>
            </template>
            <span>
              {{ props.header.text }}
            </span>
          </v-tooltip>
        </template>
      
        <template v-if="indexData.totalRejected > 0" v-slot:items="props">
          <td>{{ props.item.id }}</td>
          <td>{{ props.item.user_id }}</td>
          <td>{{ props.item.first_name }}</td>
          <td>{{ props.item.last_name }}</td>
          <td>{{ props.item.dob }}</td>
          <td>{{ props.item.nid_rejected_at }}</td>
          <td>{{ props.item.rejected_by }}</td>
          <td class="justify-center layout px-1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon small class="mr-2" v-on="on" @click="checkItem(props.item)">
                    visibility
                </v-icon>
              </template>
              <span>view</span>
            </v-tooltip>
          </td>
        </template>
        <template v-else v-slot:no-data>
          <v-alert :value="true" color="error" icon="warning">
            {{ errorMsg }}
          </v-alert>
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
        <template v-slot:pageText>
          Rows {{ indexData.userRejectedInfos.from }} - {{ indexData.userRejectedInfos.to }} of {{ indexData.userRejectedInfos.total }}
        </template>
      </v-data-table>
      <template>
        <div class="text-xs-center">
          <v-pagination
            v-model="indexData.userRejectedInfos.current_page"
            :length="indexData.userRejectedInfos.last_page"
            @input="onPageChange"
          ></v-pagination>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

  export default {
    data: () => ({
      dialog: false,
      alertMsg: false,
      apiUrl: 'nid',
      sl: 1,
      headers: [
        { text: 'ID', align: 'left', value: 'id' },
        { text: 'Dasher ID', align: 'left', value: 'user_id' },
        { text: 'First Name', align: 'left', value: 'first_name' },
        { text: 'Last Name', value: 'last_name' },
        { text: 'DOB', value: 'dob' },
        { text: 'NID rejected at', value: 'nid_rejected_at' },
        { text: 'NID rejected by', value: 'rejected_by' },
        { text: 'Actions', align: 'center', value: 'name', sortable: false }
      ],
      search: '',
      pagination: {},
      rowsPerPageItems: [5, 10, 20, 50, 100, 200, 500],
      editedIndex: -1, 
      editedItem: {
        
      },
      defaultItem: {
        
      }
    }),
    
    computed: {
      ...mapGetters(['isLoggedIn', 'indexData', 'error', 'statusCode', 'errorMsg']),
      isLoaded() {
          if (this.indexData.userRejectedInfos) {
            return true;
          } else {
            return false;
          }
      },
    },

    watch: {
      pagination() {
        this.onPageChange()
      },
      dialog (val) {
        val || this.close()
      }
    },

    created(){
      this.paginationMethod()
    },
    
    methods: {
       initialize () {
          this.$store.dispatch('changeNidStatus', ['nid-status', 3, "", 1, 5])
      },

       setErrorZero () {
        this.$store.dispatch('setErrorZero')
      },

      checkItem (item) {
        // console.log(item)
        this.editedIndex = this.indexData.userRejectedInfos.data.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        if (this.editedIndex > -1) {
          Object.assign(this.desserts[this.editedIndex], this.editedItem)
        } else {
          this.desserts.push(this.editedItem)
        }
        this.close()
      },

      onPageChange(){
        this.paginationMethod()
      },

      paginationMethod() {
        // console.log(this.search)
        this.loading = true
        if (this.indexData.userRejectedInfos) {
        if(this.search){
          this.$store.dispatch('changeNidStatus', ['nid-status', 3, this.search, this.indexData.userRejectedInfos.current_page, this.pagination.rowsPerPage])
          this.loading = (this.indexData.userRejectedInfos.data) ? false : true
        }else{
          this.$store.dispatch('changeNidStatus', ['nid-status', 3, this.search, this.indexData.userRejectedInfos.current_page, this.pagination.rowsPerPage])
          this.loading = (! this.indexData.error) ? false : true
        }
        this.dialog = false
        }
      },
    }
  }
</script>
<style lang="stylus" scoped>
  .v-progress-circular
    margin: 1rem

  .imageResize
    width: auto
    height: auto
</style>